import Swiper from 'swiper/bundle';
import { Breakpoint } from '../lib/utils';

export const initCarousels = () => {
	const els = document.querySelectorAll('.js-swiper-container');

	for (const el of els) {
		createCarousel(el);
	}
};

/**
 * Creates a Swiper/carousel component.
 * @param {HTMLElement} containerEl - Carousel **container** element.
 */
const createCarousel = (containerEl) => {
	const
		swiperEl = containerEl.querySelector('.js-swiper'),
		controlsEl = containerEl.querySelector('.js-swiper-controls'),
		prevBtnEl = controlsEl?.querySelector('.js-swiper-button-prev'),
		nextBtnEl = controlsEl?.querySelector('.js-swiper-button-next'),
		paginationEl = controlsEl?.querySelector('.js-swiper-pagination');

	if (
		!swiperEl
		|| !controlsEl
		|| !prevBtnEl
		|| !nextBtnEl
		|| !paginationEl
	) {
		throw new Error('Missing carousel elements');
	}

	// operation unreadable code is a go
	const maxSlidesPerView = swiperEl.dataset.maxSlidesPerView
		&& parseInt(swiperEl.dataset.maxSlidesPerView)
		|| 4;

	const
		cn = 'carousel',
		sliCn = `${cn}__slide`,
		btnCn = `${cn}__btn`,
		pagCn = `${cn}__pagination`;

	const swiper = new Swiper(swiperEl, {
		slidesPerView: 1,
		spaceBetween: 28, // per figma
		wrapperClass: 'js-swiper-wrapper',
		slideClass: sliCn,
		noSwipingClass: `${cn}--no-swiping`,
		slideNextClass: `${sliCn}--next`,
		slidePrevClass: `${sliCn}--prev`,
		slideBlankClass: `${sliCn}--blank`,
		slideActiveClass: `${sliCn}--active`,
		slideVisibleClass: `${sliCn}--visible`,
		lazyPreloaderClass: `${cn}__lazy-preloader`,
		slideFullyVisibleClass: `${sliCn}--fully-visible`,
		containerModifierClass: `${cn}--`,
		navigation: {
			prevEl: prevBtnEl,
			nextEl: nextBtnEl,
			hiddenClass: `${btnCn}--hidden`,
			lockClass: `${btnCn}--locked`,
			disabledClass: `${btnCn}--disabled`,
			navigationDisabledClass: `${cn}__navigation--disabled`
		},
		pagination: {
			el: paginationEl,
			clickable: true,
			bulletClass: `${pagCn}-bullet`,
			bulletActiveClass: `${pagCn}-bullet--active`,
			clickableClass: `${pagCn}--clickable`,
			currentClass: `${pagCn}--current`,
			hiddenClass: `${pagCn}--hidden`,
			horizontalClass: `${pagCn}--horizontal`,
			modifierClass: `${pagCn}--`,
			paginationDisabledClass: `${pagCn}--disabled`,
			lockClass: `${pagCn}--locked`,
			progressbarFillClass: `${pagCn}-progressbar--fill`,
			progressbarOppositeClass: `${pagCn}-progressbar--opposite`,
			totalClass: `${pagCn}-total`,
			verticalClass: `${pagCn}--vertical`
		},
		breakpoints: {
			[Breakpoint.MD]: {
				slidesPerView: 2
			},
			[Breakpoint.LG]: {
				slidesPerView: maxSlidesPerView
			}
		}
	});

	const updateLocked = () => {
		swiperEl.classList.toggle(
			cn + '--locked',
			swiper.isLocked
		);
	};

	updateLocked();
	swiper.on('lock', updateLocked);
	swiper.on('unlock', updateLocked);
};
